/*
 * @Author: Tina Huang
 * @Date: 2025-01-26 14:49:44
 * @LastEditors: Tina Huang
 * @LastEditTime: 2025-02-26 15:36:21
 * @Description:
 */

import { useEffect, useMemo, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeColorChips from 'rehype-color-chips'
// import SyntaxHighlighter from 'react-syntax-highlighter'

import { qaList } from '@/constants/qa'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { Rate } from 'antd'

export default function QADetail() {
  const { id } = useParams()
  const [mdStr, setMdStr] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    fetch(`/QA-Answer/${id}.md`)
      .then((resp) => resp?.text())
      .then((txt) => setMdStr(txt))
  }, [id])

  const returnPrePage = () => {
    navigate(-1)
  }

  const item = useMemo(() => {
    return qaList.find((cur) => cur.id === id)
  }, [id])

  return (
    <div className="prose w-full bg-white p-8 rounded-lg">
      <div className="cursor-pointer" onClick={returnPrePage}>
        <ArrowLeftOutlined /> 返回
      </div>
      <h1 className="text-center mt-8">{item?.title}</h1>
      <div className="text-center">{/* <Rate disabled value={item?.level} character="🔥" className="m-0 leading-none" /> */}</div>
      <Markdown remarkPlugins={[remarkGfm]} rehypePlugins={[rehypeColorChips]}>
        {mdStr}
      </Markdown>
    </div>
  )
}
